(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (section.dataset.blogInfiniteReady === 'true') return;

      const grid = section.querySelector('.row');
      const sentinel = section.querySelector('[data-blog-sentinel]');
      const pagination = section.querySelector('[data-blog-pagination]');
      const nextLink = section.querySelector('[data-blog-next]');

      if (!grid || !sentinel || !pagination || !nextLink || !('IntersectionObserver' in window)) return;

      section.dataset.blogInfiniteReady = 'true';
      let loading = false;

      const observer = new IntersectionObserver(async (entries) => {
        if (!entries[0].isIntersecting || loading) return;

        const nextUrl = sentinel.dataset.nextUrl;
        if (!nextUrl) {
          observer.disconnect();
          return;
        }

        loading = true;
        section.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(nextUrl, {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });

          if (!response.ok) throw new Error('Unable to load the next blog page.');

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const incomingSection = documentFragment.getElementById(section.id);
          const incomingGrid = incomingSection && incomingSection.querySelector('.row');

          if (!incomingGrid) throw new Error('The next blog page did not contain an article grid.');

          Array.from(incomingGrid.children).forEach((card) => grid.appendChild(card));

          const incomingSentinel = incomingSection.querySelector('[data-blog-sentinel]');
          const incomingNextLink = incomingSection.querySelector('[data-blog-next]');

          if (incomingSentinel && incomingNextLink) {
            sentinel.dataset.nextUrl = incomingSentinel.dataset.nextUrl;
            nextLink.href = incomingNextLink.href;
          } else {
            observer.disconnect();
            pagination.remove();
            sentinel.remove();
          }
        } catch (error) {
          observer.disconnect();
        } finally {
          loading = false;
          section.removeAttribute('aria-busy');
        }
      }, { rootMargin: '600px 0px' });

      observer.observe(sentinel);
    };

    document.querySelectorAll('[data-blog-infinite-scroll]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-blog-infinite-scroll]');
      if (section) initialize(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featureon"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function(){
        jQuery('.logoslidefea').slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,autoplay: true,autoplaySpeed: 2000,dots:false,arrows:false,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ve-blog-page"]) return;
  try {
    
$(document).ready(function(){
  var num = 1;
  $(document.body).on('click', '.blog_showmore a', function(e){
    num++; e.preventDefault(); var t = $(this);
    var p = t.data('totalpages'); 
    t.after('<div id="loader" class="spinner-grow text-dark"></div>');
   if( num <= p ){
     $.ajax({
       type:"get",
       url:"https://veganessentials.com/blogs/news/?page="+num,
       success: function(resp){
         var data = $(resp).find('.ve_news_list').html();
         $('#ve_news_list').append(data);
       },
       complete: function(){
         $('#loader').remove();
       }
     });  
   } 
    if( num == p ){ t.hide(); }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ve-main-article-parent"] && !Shopify.designMode) return;
  try {
    
  //   jQuery(document).ready(function($){
  //     // Function to wrap the word "Fructose" with a span
  //     function highlightFructose() {
  //     const tooltipText = "Fructose is a sugar found naturally in fruits, fruit juices, some vegetables and honey. Table sugar, called sucrose, also has fructose. High-fructose corn syrup is a sweetener that is in many processed foods and drinks.  <a href=\"https://liv3health.com/pages/fructose\" target=\"_blank\">Read More</a>";

  //     $('.innerblobdiv h1, .innerblobdiv h2, .innerblobdiv h3, .innerblobdiv h4, .innerblobdiv h5, .innerblobdiv h6, .innerblobdiv p, .innerblobdiv a, .innerblobdiv span').html(function (_, html) {
  //         return html.replace(/(Fructose)/g,
  //             `<span class="highlight-with-tooltip">Fructose
  //                 <span class="custom-tooltip">${tooltipText}</span>
  //             </span>`);
  //     });
  // }
  // highlightFructose();

  //   });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ve-main-article"]) return;
  try {
    
//   jQuery(document).ready(function($){
//     // Function to wrap the word "Fructose" with a span
//     function highlightFructose() {
//     const tooltipText = "Fructose is a sugar found naturally in fruits, fruit juices, some vegetables and honey. Table sugar, called sucrose, also has fructose. High-fructose corn syrup is a sweetener that is in many processed foods and drinks.  <a href=\"https://liv3health.com/pages/fructose\" target=\"_blank\">Read More</a>";


//     $('.innerblobdiv h1, .innerblobdiv h2, .innerblobdiv h3, .innerblobdiv h4, .innerblobdiv h5, .innerblobdiv h6, .innerblobdiv p, .innerblobdiv a, .innerblobdiv span').html(function (_, html) {
//         return html.replace(/(Fructose)/g, 
//             `<span class="highlight-with-tooltip">Fructose
//                 <span class="custom-tooltip">${tooltipText}</span>
//             </span>`);
//     });
// }
// highlightFructose();

//   });

  } catch(e) { console.error(e); }
})();
})();
